import { render, staticRenderFns } from "./LinhaDeParcelasDetalhes.vue?vue&type=template&id=92969692&scoped=true"
import script from "./LinhaDeParcelasDetalhes.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeParcelasDetalhes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeParcelasDetalhes.vue?vue&type=style&index=0&id=92969692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92969692",
  null
  
)

export default component.exports